import { create } from 'zustand'

import { api, tokenStore, type AdminMe } from '../api/client'

interface AuthState {
  me: AdminMe | null
  loading: boolean
  /** 页面刷新后用本地 token 换回身份；token 无效时静默登出 */
  restore: () => Promise<void>
  login: (username: string, password: string) => Promise<void>
  logout: () => void
}

export const useAuth = create<AuthState>((set) => ({
  me: null,
  loading: true,

  restore: async () => {
    if (!tokenStore.get()) {
      set({ me: null, loading: false })
      return
    }
    try {
      set({ me: await api.get<AdminMe>('/admin/auth/me'), loading: false })
    } catch {
      tokenStore.clear()
      set({ me: null, loading: false })
    }
  },

  login: async (username, password) => {
    const res = await api.post<{ token: string; admin: AdminMe }>('/admin/auth/login', {
      username,
      password,
    })
    tokenStore.set(res.token)
    set({ me: res.admin })
  },

  logout: () => {
    tokenStore.clear()
    set({ me: null })
  },
}))
